




























































































































import { Vue, Component, Prop, Inject, Watch } from "vue-property-decorator";
import { mapState } from "vuex";
import _ from "@/boot/lodash";

// Enums/Data
import { FilterOperators, FilterTypes } from "@/data/table";
import { DynamicSettingsFieldTypes } from "@/data/enums/fields";

// Types
import {
  IReportProviderData,
  IReportProviderMethods
} from "@/models/providers/reports";
import { IState } from "@/store";
import { IBrand } from "@/models/brands";
import { IFilter } from "@/models/tables";

@Component({
  computed: {
    ...mapState({
      brandId(state: IState) {
        return state.brand.id;
      }
    })
  },
  components: {
    "u-resizable-table": () =>
      import("@/components/app-base/UResizableTable.vue"),
    "report-records-provider": () =>
      import("@/components/app/admin/insights/reportRecordsProvider.vue"),
    "dynamic-column-cell": () =>
      import("@/components/app/global/dynamicColumns/dynamicColumnCell.vue")
  }
})
export default class ReportRecordsListing extends Vue {
  // Map state
  public brandId!: IBrand["id"];

  // Inject

  @Inject({ from: "reportProviderData" })
  public readonly $reportProviderData!: () => IReportProviderData;

  public get $reportData() {
    return this.$reportProviderData();
  }

  @Inject({ from: "reportProviderMethods" })
  public readonly $reportMethods!: IReportProviderMethods;

  // Props

  @Prop({ required: true })
  public params!: any;

  @Prop({ required: true })
  public row!: any;

  @Prop({ required: true })
  public code!: string;

  // Variables

  public page = 1;
  public limit = 10;
  public activeFilters: IFilter[] = [];

  // Computed

  public get tableColumns() {
    return _.map(this.row, (value, key) => {
      return {
        id: key,
        field: key,
        label: key,
        thAttr: {
          class: "is-compact",
          style: { width: "200px" }
        }
      };
    });
  }

  public get preparedFilters() {
    return _.map(
      _.filter(
        this.params,
        filter => filter.code !== "limit" && filter.code !== "offset"
      ),
      filter => ({
        key: filter.code,
        label: filter.name,
        type: this.getFilterType(filter.field_type),
        operator: FilterOperators.EQUAL,
        options: _.map(filter.options, option => {
          option.id = option.value;
          return option;
        })
      })
    );
  }

  public get hasPaginationEnabled() {
    return (
      _.some(this.params, ["code", "limit"]) &&
      _.some(this.params, ["code", "offset"])
    );
  }

  public get filters() {
    return {
      ...(this.hasPaginationEnabled
        ? {
            limit: this.limit,
            offset: (this.page - 1) * this.limit
          }
        : {}),
      ..._.mapValues(_.keyBy(this.activeFilters, "key"), "value")
    };
  }

  public getFilterType(filterType) {
    switch (filterType) {
      case DynamicSettingsFieldTypes.CHECKBOX:
        return FilterTypes.SELECT_CHECKBOX;
      case DynamicSettingsFieldTypes.DATE:
        return FilterTypes.DATE;
      case DynamicSettingsFieldTypes.NUMBER:
        return FilterTypes.NUMBER;
      case DynamicSettingsFieldTypes.RADIO:
        return FilterTypes.SELECT_RADIO;
      case DynamicSettingsFieldTypes.SELECT:
        return FilterTypes.SELECT;
      case DynamicSettingsFieldTypes.TEXT:
        return FilterTypes.STRING;
      case DynamicSettingsFieldTypes.MULTIPLE:
        return FilterTypes.SELECT_MULTI;
      default:
        return "";
    }
  }

  // Methods

  public onFiltersChange(filters: IFilter[]) {
    this.activeFilters = filters;
  }

  public onPageChange(page: number) {
    this.page = page;
  }

  public onLimitChange(limit: number) {
    this.limit = limit;
  }

  @Watch("filters")
  public changeFilters() {
    this.$reportMethods.updateFilters(this.filters);
  }
}
